import { action, props } from 'ts-action';
import { LayoutState } from '../types/layout-state.type';

export const toggle = action(
  '[Layout] toggle',
  props<{ key: keyof LayoutState }>(),
);

export const update = action(
  '[Layout] update',
  props<{ update: Partial<LayoutState> }>(),
);
